import axios from "axios";

const instance = axios.create({
  // baseURL: "http://localhost:5000",
  baseURL: "https://pbl5.herokuapp.com", //change with backend hosted domain
});

export default instance;
